module.exports = __webpack_public_path__ + "static/media/pic1.be325b1a.jpg";